import { publicUsageReport, usage } from "../../constants/actionTypes";

const getUsageSummaryData = (data) => ({
  type: usage.USAGE_SUMMARY_GET_DATA,
  payload: data,
});

const setUsageSummaryData = (data) => ({
  type: usage.USAGE_SUMMARY_SET_DATA,
  payload: data,
});

const setUsageSummaryError = (data) => ({
  type: usage.USAGE_SUMMARY_SET_ERROR,
  payload: data,
});

const setSummaryLoading = (data) => ({
  type: usage.SET_SUMMARY_LOADING,
  payload: data,
});

const generateReportRequest = (data) => ({
  type: usage.USAGE_REPORT_GENERATE_REQUEST,
  payload: data,
});

const generateReportSuccess = (data) => ({
  type: usage.USAGE_REPORT_GENERATE_SUCCESS,
  data: data,
});

const generateReportError = (data) => ({
  type: usage.USAGE_REPORT_GENERATE_ERROR,
  data: data,
});

const setGenerateReportLoading = (data) => ({
  type: usage.SET_GENERATE_REPORT_LOADING,
  payload: data,
});

const getReportListData = (data) => ({
  type: usage.REPORT_LIST_GET_DATA,
  payload: data,
});

const setReportListData = (data) => ({
  type: usage.REPORT_LIST_SET_DATA,
  payload: data,
});

const setReportListError = (data) => ({
  type: usage.REPORT_LIST_SET_ERROR,
  payload: data,
});

const setReportListLoading = (data) => ({
  type: usage.SET_REPORT_LIST_LOADING,
  payload: data,
});

const setWebSocketUsageList = (data) => ({
  type: usage.SET_WEBSOCKET_USAGE_LIST_DATA,
  payload: data,
});

const getUsageReportSkuLoading = (urlParams) => ({
  type: usage.GET_REPORT_SKU_LOADING,
  payload: urlParams,
});

const getUsageReportSkuAction = (urlParams) => ({
  type: usage.GET_REPORT_SKU_ACTION,
  payload: urlParams,
});

const getUsageReportSkuSuccess = (urlParams) => ({
  type: usage.GET_REPORT_SKU_SUCCESS,
  payload: urlParams,
});

const getUsageReportSkuError = (urlParams) => ({
  type: usage.GET_REPORT_SKU_ERROR,
  payload: urlParams,
});

const getUsageReportSkuReset = () => ({
  type: usage.GET_REPORT_SKU_RESET,
});

// Usage Users Actions

const getUsageUserListLoading = (urlParams) => ({
  type: usage.GET_USAGE_USER_LIST_LOADING,
  payload: urlParams,
});

const getUsageUserListAction = (urlParams) => ({
  type: usage.GET_USAGE_USER_LIST_ACTION,
  payload: urlParams,
});

const getUsageUserListSuccess = (urlParams) => ({
  type: usage.GET_USAGE_USER_LIST_SUCCESS,
  payload: urlParams,
});

const getUsageUserListError = (urlParams) => ({
  type: usage.GET_USAGE_USER_LIST_ERROR,
  payload: urlParams,
});

const getUsageUserListReset = () => ({
  type: usage.GET_USAGE_USER_LIST_RESET,
});

const getPublicReportListData = (data) => ({
  type: publicUsageReport.PUBLIC_REPORT_LIST_GET_DATA,
  payload: data,
});

const setPublicReportListData = (data) => ({
  type: publicUsageReport.PUBLIC_REPORT_LIST_SET_DATA,
  payload: data,
});

const setPublicReportListError = (data) => ({
  type: publicUsageReport.PUBLIC_REPORT_LIST_SET_ERROR,
  payload: data,
});

const setPublicReportListLoading = (data) => ({
  type: publicUsageReport.SET_PUBLIC_REPORT_LIST_LOADING,
  payload: data,
});

const generatePublicReportRequest = (data) => ({
  type: publicUsageReport.PUBLIC_USAGE_REPORT_GENERATE_REQUEST,
  payload: data,
});

const generatePublicReportSuccess = (data) => ({
  type: publicUsageReport.PUBLIC_USAGE_REPORT_GENERATE_SUCCESS,
  data: data,
});

const generatePublicReportError = (data) => ({
  type: publicUsageReport.PUBLIC_USAGE_REPORT_GENERATE_ERROR,
  data: data,
});

const setPublicGenerateReportLoading = (data) => ({
  type: publicUsageReport.SET_PUBLIC_GENERATE_REPORT_LOADING,
  payload: data,
});

export {
  getUsageSummaryData,
  setUsageSummaryData,
  setUsageSummaryError,
  setSummaryLoading,
  generateReportRequest,
  generateReportSuccess,
  generateReportError,
  setGenerateReportLoading,
  getReportListData,
  setReportListData,
  setReportListError,
  setReportListLoading,
  setWebSocketUsageList,
  getUsageReportSkuLoading,
  getUsageReportSkuAction,
  getUsageReportSkuSuccess,
  getUsageReportSkuError,
  getUsageReportSkuReset,
  getUsageUserListLoading,
  getUsageUserListAction,
  getUsageUserListSuccess,
  getUsageUserListError,
  getUsageUserListReset,
  getPublicReportListData,
  setPublicReportListData,
  setPublicReportListError,
  setPublicReportListLoading,
  generatePublicReportRequest,
  generatePublicReportSuccess,
  generatePublicReportError,
  setPublicGenerateReportLoading,
};
